"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHeaderSection = void 0;
exports.defaultHeaderSection = {
    translate: {
        title: 'Insights',
        tag: 'Tag:',
    },
};
